import { useEffect, useState } from "react";
import useAuth from "../hook/useAuth";
import { getCourseCategories, post_Course } from "../services/Course";
import { AddCourseCategory } from "./AddCourseCategory";
import { PleasewaitPopup } from "./PleasewaitPopup";

type AddCourseProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshCourseList: (value: boolean) => void;
}

export const AddCourse = ({ showPopup, setShowPopup, setRefreshCourseList }: AddCourseProps) => {
    const { auth }: any = useAuth();
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [filterCourseCategoryList, setFilterCourseCategoryList] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [selectedCourseCategory, setSelectedCourseCategory] = useState<number>(0);
    const [courseCategoryList, setCourseCategoryList] = useState<any[]>([]);
    const [courseCategoryListLoaded, setCourseCategoryListLoaded] = useState<boolean>(false);
    const [showAddCourseCategoryPopup, setShowAddCourseCategoryPopup] = useState<boolean>(false);
    const [refreshCourseCategory, setRefreshCourseCategory] = useState<boolean>(true);
    const [courseTitle, setCourseTitle] = useState<string>("");
    const [courseDiscription, setCourseDiscription] = useState<string>("");
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    useEffect(() => {
        if (refreshCourseCategory) {
            setCourseCategoryListLoaded(false);
            getCourseCategories()
                .then((data) => {
                    setCourseCategoryList(data);
                    setFilterCourseCategoryList(data);
                    setCourseCategoryListLoaded(true);
                    setRefreshCourseCategory(false);
                })
                .catch((error) => {
                    setCourseCategoryList([]);
                    setFilterCourseCategoryList([]);
                    setCourseCategoryListLoaded(true);
                    setRefreshCourseCategory(false);
                    console.error(error)
                })
        }
    }, [refreshCourseCategory])

    useEffect(() => {
        const filteredCourseCategories = courseCategoryList
            .filter((category) => category?.name.toLowerCase().includes(searchValue.toLowerCase()))

        setFilterCourseCategoryList(filteredCourseCategories)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue])


    if (!showPopup) return null;

    const handleNextClick = () => {
        if (currentStep === 1) {
            setCurrentStep(2);
        }
        else if (currentStep === 2 && selectedCourseCategory > 0 && courseTitle) {
            setShowPleasewait(true);
            post_Course({
                courseCategoryId: selectedCourseCategory,
                title: courseTitle,
                description: courseDiscription,
                isPublished: false,
                userId: auth?.id,
                createdAt: new Date().toLocaleString(),
                createdBy: auth?.givenname
            }, auth?.id)
                .then((res) => {
                    setShowPleasewait(false);
                    setShowPopup(false);
                    setRefreshCourseList(true);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    const handleBackClick = () => {
        if (currentStep === 2) {
            setCurrentStep(1)
        }
    }

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-3xl rounded-md shadow-lg max-h-[90vh] flex flex-col">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Add course</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>
                    {
                        currentStep === 1 && (
                            <div className="px-6 py-6 overflow-y-auto flex-1">
                                <div className="flex items-center justify-between py-2">
                                    <h3 className="text-lg font-medium mb-2">
                                        Select Course Category
                                    </h3>

                                    <button
                                        className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                        onClick={() => setShowAddCourseCategoryPopup(true)}
                                    >
                                        Create new category
                                    </button>
                                </div>


                                {/* Search box */}
                                <input
                                    type="text"
                                    placeholder="Search for a course category"
                                    className="w-full border rounded px-3 py-2 mb-6 text-sm focus:outline-none focus:ring focus:ring-primary"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />

                                {/* Course categories */}
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                                    {filterCourseCategoryList?.map((item: any, index: number) => (
                                        <div key={index}>
                                            <label className="flex items-center space-x-2 text-sm cursor-pointer">
                                                <input
                                                    type="radio"
                                                    name="course"
                                                    value={item?.id}
                                                    checked={selectedCourseCategory === item?.id}
                                                    onChange={() => setSelectedCourseCategory(item?.id)}
                                                />
                                                <span>{item?.name}</span>
                                            </label>
                                        </div>
                                    ))}


                                </div>
                                {
                                    !courseCategoryListLoaded && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <div className="mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                        </div>
                                    )
                                }

                                {
                                    (courseCategoryListLoaded && filterCourseCategoryList.length === 0) && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <span className="text-lg text-gray-400">No category found!</span>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }

                    {
                        currentStep === 2 && (
                            <>
                                <div className="px-6 pt-6 space-y-4">

                                    <label className="font-medium">Course Title</label>
                                    <input
                                        type="text"
                                        placeholder="Title"
                                        className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                        value={courseTitle}
                                        onChange={(e) => setCourseTitle(e.target.value)}
                                    />

                                </div>

                                <div className="px-6 py-6 space-y-4">
                                    <label className="font-medium">Course Description</label>
                                    <textarea
                                        rows={3}
                                        placeholder="Description"
                                        className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                        value={courseDiscription}
                                        onChange={(e) => setCourseDiscription(e.target.value)}
                                    />
                                </div>
                            </>
                        )
                    }



                    {/* Footer */}
                    <div className="px-6 py-4 border-t flex justify-between space-x-3">
                        <button
                            className={`px-6 py-2 ${currentStep === 1 ? "bg-gray-300 text-white cursor-not-allowed" : currentStep === 2 ? "bg-white text-primary border border-primary cursor-pointer" : "bg-gray-300 text-white cursor-not-allowed"}  font-medium rounded`}
                            disabled={currentStep === 1 ? true : currentStep === 2 ? false : true}
                            onClick={handleBackClick}
                        >
                            Back
                        </button>

                        <button
                            className={`px-6 py-2 ${currentStep === 1 && selectedCourseCategory === 0 ? "bg-gray-300 text-white cursor-not-allowed" : currentStep === 2 && !courseTitle ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={currentStep === 1 && selectedCourseCategory === 0 ? true : currentStep === 2 && !courseTitle ? true : false}
                            onClick={handleNextClick}
                        >
                            {currentStep === 1 ? "Next" : "Save"}
                        </button>
                    </div>
                </div>
            </div >

            {
                showAddCourseCategoryPopup && (
                    <AddCourseCategory showPopup={showAddCourseCategoryPopup} setShowPopup={setShowAddCourseCategoryPopup} setRefreshCourseCategory={setRefreshCourseCategory} />
                )
            }

            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}